module.exports = __webpack_public_path__ + "img/vuetify.ffe16d74.svg";